/* eslint-disable radix */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';

import InputMask from 'react-input-mask';
import { I18n } from 'react-redux-i18n';
import isEmail from 'validator/lib/isEmail';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';

import { buscaCep, checkRegister, newRegister } from '../app/store/actions/newRegister';
import StringHelper from '../helpers/string';
import ValidatorsHelper from '../helpers/validators';

import inputSize from '../data/inputs';

import rdStation from '../app/services/rdStation';
import tagManager from '../app/services/tagManager';
import { recoverPassword } from '../app/store/actions/solicitation';

class NewRegisterPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = this.cleanData();
  }

  componentDidMount = () => {
    removeScript('/scripts/panel.min.js');
    appendScript('/scripts/panel.min.js');

    scrollToTopAnimated();
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  }

  componentDidUpdate = (prevProps, prevState) => {
    if ((this.state.finalize && this.state.finalize !== prevState.finalize)
    || (this.state.finalizeError && this.state.finalizeError !== prevState.finalizeError)) {
      scrollToTopAnimated();
    }
    this.mandatoryStateRegistration();
  }

  mandatoryStateRegistration = () => {
    const { company } = this.state;
    if (company.purpose === 'resale' && !company.hasIe) {
      this.setValue('company', 'hasIe', true);
    }
  }

  onChangePassword = (password) => {
    const characterLengthRegx = /^.{9,}$/;
    const isNumberRegx = /[0-9]/;
    const specialCharacterRegx = /[!@#$%^&*]/;
    const upperCaseCharacterRegx = /[A-Z]/;
    this.setValue('user', 'password', password);
    this.setState({
      passwordValidity: {
        minChar: characterLengthRegx.test(password),
        number: isNumberRegx.test(password),
        upperCase: upperCaseCharacterRegx.test(password),
        specialChar: specialCharacterRegx.test(password),
      },
    });
  }

  cleanData = () => ({
    activeStep: 0,
    finalize: false,
    finalizeError: false,
    emailError: '',
    cnpjError: '',
    cepError: '',
    // passwordError: '',
    // confirmPasswordError: '',
    // showTooltipPassword: false,
    // passwordValidity: {
    //   minChar: null,
    //   number: null,
    //   upperCase: null,
    //   specialChar: null,
    // },
    cepChanged: false,
    error: '',
    type: '',
    basic: {
      cnpj: '',
      email: '',
      rut: '',
    },
    address: {
      cep: '',
      ibge: '',
      street: '',
      number: '',
      complement: '',
      district: '',
      city: '',
      state: '',
      country: '',
    },
    user: {
      firstName: '',
      lastName: '',
      birthDate: '',
      role: '',
      sector: '',
      phone: '',
      // password: '',
      // confirmPassword: '',
    },
    company: {
      name: '',
      ie: '',
      purpose: 'consumption',
      business: '',
    },
    taxBenefits: {
      naoContribIcms: false,
      icmsIsento: false,
      icmsDiferido: false,
      pisCofins: false,
      ipi: false,
      proEmprego: false,
    },
  })

  setBasic = async (basic) => {
    this.setState({ basic });
  };

  setAddress = async (address) => {
    this.setState({ address });
  };

  setUser = async (user) => {
    this.setState({ user });
  };

  setCompany = async (company) => {
    this.setState({ company });
  };

  setTaxBenefits = async (taxBenefits) => {
    this.setState({ taxBenefits });
  };

  setType = async (type) => {
    this.setState({ type });
  };

  setValue = async (key, attr, value) => {
    const keyValue = this.state[key];
    const specific = {};

    if ('password|confirmPassword'.includes(attr)) {
      specific.passwordError = '';
      specific.confirmPasswordError = '';
    }

    if (attr === 'hasIe' && !value) {
      keyValue.ie = '';
    }

    this.setState({
      [`${attr}Error`]: '',
      [`${attr}Changed`]: true,
      [key]: { ...keyValue, [`${attr}`]: value },
      ...specific,
    });
  }

  normalizeData = (data) => {
    if (typeof data === 'string') return data.trim();

    return data;
  }

  handleFinalize = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const asyncFunc = async () => {
      const {
        basic, user, address, company,
        taxBenefits, type, emailError,
        cnpjError, cepError,
      } = this.state;
      const { rdStationApiKey = '', roles = [] } = this.props;
      const userRole = user.role ? roles.find(it => `${it.id}` === `${user.role}`) || '' : '';

      if (emailError || cnpjError || cepError) return;

      try {
        const register = {
          cnpj: this.normalizeData(StringHelper.keepOnlyNumber(basic.cnpj)),
          type: this.normalizeData(type),
          rut: this.normalizeData(StringHelper.keepOnlyNumber(basic.rut)),
          email: this.normalizeData(this.normalizeData(basic.email)),
          cep: this.normalizeData(StringHelper.keepOnlyNumber(address.cep)),
          ibge: this.normalizeData(address.ibge),
          address: this.normalizeData(address.street),
          number: this.normalizeData(address.number),
          complement: this.normalizeData(address.complement),
          district: this.normalizeData(address.district),
          city: this.normalizeData(address.city),
          state: this.normalizeData(address.state),
          country: this.normalizeData(address.country),
          firstName: this.normalizeData(user.firstName),
          lastName: this.normalizeData(user.lastName),
          birthDate: this.normalizeData(user.birthDate),
          role: this.normalizeData(user.role),
          sector: this.normalizeData(user.sector),
          phone: this.normalizeData(user.phone.replace(/_/g, '')),
          // password: this.normalizeData(user.password),
          companyName: this.normalizeData(company.name),
          stateRegistration: this.normalizeData(company.ie || 'ISENTO'),
          purpose: this.normalizeData(company.purpose),
          business: this.normalizeData(company.business),
          naoContribIcms: this.normalizeData(company.ie ? taxBenefits.naoContribIcms : true),
          icmsIsento: this.normalizeData(taxBenefits.icmsIsento),
          icmsDiferido: this.normalizeData(taxBenefits.icmsDiferido),
          pisCofins: this.normalizeData(taxBenefits.pisCofins),
          ipi: this.normalizeData(taxBenefits.ipi),
          proEmprego: this.normalizeData(taxBenefits.proEmprego),
        };

        const newRegisterCheckBuy = await this.props.newRegister(register);

        tagManager.newUserRegister();
        rdStation.sendConversion({
          name: `${user.firstName} ${user.lastName}`,
          email: basic.email,
          role: userRole ? userRole.name.trim() : '',
          state: address.state,
          city: address.city,
          country: address.country,
          phoneOnlyNumber: StringHelper.keepOnlyNumber(user.phone),
          phone: user.phone.replace(/_/g, ''),
          company_name: company.name,
          company_address: `${address.street} - ${address.number} | ${address.district}`,
        }, rdStationApiKey);

        if (newRegisterCheckBuy) {
          if (newRegisterCheckBuy.status === 'finish') {
            this.setState({ finalize: true, error: '' });
          } else {
            this.setState({
              finalizeError: true,
              error: '',
            });
          }
        } else {
          this.setState({
            finalizeError: true,
            error: '',
          });
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          if (err.response.data.error.code && err.response.data.error.code === 106) {
            this.setState({
              finalizeError: true,
              error: '',
            });
          }
          //  else if (err.response.data.error.code && err.response.data.error.code === 412) {
          //   this.setState({
          //     error: I18n.t('errorPasswordPolicy'),
          //   });
          // }
          else if (err.response.data.error.code && err.response.data.error.code === 404) {
            this.setState({
              error: I18n.t('emailCnpjMessage4'),
            });
          } else {
            this.setState({ error: `${I18n.t('code2')} ${err.response.data.error.code}` });
          }
        }
      }
    };

    asyncFunc();
  }

  onBlurBasic = async (field, value) => {
    value = value.trim();

    if (!value) return;

    let errEmail = '';
    let errCnpj = '';

    if (field === 'email' && !isEmail(value)) {
      this.setState({ emailError: I18n.t('invalidEmail') });
    } else if (field === 'email' && !value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z]+\.)+[a-zA-Z]{2,}))$/g)) {
      this.setState({ emailError: I18n.t('invalidEmail') });
    } else if (field === 'cnpj' && !ValidatorsHelper.validarCNPJ(value)) {
      this.setState({ cnpjError: I18n.t('invalidCNPJ') });
    } else if (field === 'cpf' && !ValidatorsHelper.validarCPF(value)) {
      this.setState({ cnpjError: I18n.t('invalidCPF') });
    }

    const { basic, emailChanged, cnpjChanged } = this.state;
    const { email, cnpj } = basic;

    if (email && cnpj && (emailChanged || cnpjChanged)) {
      try {
        this.setState({ emailChanged: false, cnpjChanged: false });
        await this.props.check(email, cnpj, cnpj.length === 14 ? 'cnpj' : 'cpf');
        this.setState({
          type: cnpj.length === 14 ? 'cnpj' : 'cpf',
        });

        if (this.state.emailError === I18n.t('emailCnpjMessage4')) errEmail = '';
        else errEmail = this.state.emailError;
        if (this.state.cnpjError === I18n.t('emailCnpjMessage4')) errCnpj = '';
        else errCnpj = this.state.cnpjError;

        this.setState({ emailError: errEmail, cnpjError: errCnpj });
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          if (err.response.data.error.code === 404 || err.response.data.error.code === 400) {
            this.setState({ emailError: I18n.t('emailCnpjMessage4'), cnpjError: I18n.t('emailCnpjMessage4') });
          } else if (err.response.data.error.code && err.response.data.error.code === 201) {
            this.setState({
              emailError: I18n.t('invalidEmail'),
            });
          }
        }
      }
    }
  }

  onBlurUser = (field) => {
    if ('password|confirmPassword'.includes(field)) {
      const { passwordValidity } = this.state;
      const {
        password, confirmPassword,
      } = this.state.user;

      if (!passwordValidity.minChar) {
        this.setState({ [`${field}Error`]: I18n.t('passwordErrorMinChar') });
        return;
      }
      if (!passwordValidity.number) {
        this.setState({ [`${field}Error`]: I18n.t('passwordErrorNumber') });
        return;
      }
      if (!passwordValidity.upperCase) {
        this.setState({ [`${field}Error`]: I18n.t('passwordErrorUpperCase') });
        return;
      }
      if (!passwordValidity.specialChar) {
        this.setState({ [`${field}Error`]: I18n.t('passwordErrorSpecialChar') });
        return;
      }

      if (password && confirmPassword && password !== confirmPassword) {
        this.setState({
          passwordError: I18n.t('passwordDifferents'),
          confirmPasswordError: I18n.t('passwordDifferents'),
        });
      }
    }
  }

  onBlurAddress = async (field, value) => {
    if (field === 'cep' && this.state.cepChanged && StringHelper.keepOnlyNumber(value)) {
      try {
        const address = await this.props.buscaCep(StringHelper.keepOnlyNumber(value));
        if (address.erro) {
          this.setState({ cepError: I18n.t('invalidCep') });
        } else {
          this.setState({
            cepChanged: false,
            cepError: '',
            address: {
              cep: value,
              street: address.logradouro,
              ibge: address.ibge,
              number: '',
              complement: '',
              district: address.bairro,
              city: address.localidade,
              state: address.uf,
              country: 'Brasil',
            },
          });
        }
      } catch (e) {
        this.setState({ cepError: I18n.t('invalidCep') });
      }
    }
  }

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  formatCpnjCpf = (value, opcoRegisterCPF) => {
    if (opcoRegisterCPF && value.length <= 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
    }

    return value.substring(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }

  validateEmail = value => value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z]+\.)+[a-zA-Z]{2,}))$/g)

  removeMarkCnpjCpf = value => value.replace(/(\.|\/|\-)/g, '');

  onClickGoToLogin = () => {
    if (this.props.headerRef && this.props.headerRef.current) {
      this.props.headerRef.current.openSideLogin();
    }
  }

  render() {
    const {
      emailError, cnpjError, passwordError, confirmPasswordError,
      cepError, error, type, basic, address, user, company,
      finalize, finalizeError, passwordValidity, showTooltipPassword,
    } = this.state;

    const { email, cnpj } = basic;

    const {
      cep, street, number, complement,
      district, city, state, country,
    } = address;

    const {
      firstName, phone,
      lastName, sector, role, password, confirmPassword, birthDate,
    } = user;

    const {
      name, hasIe, ie, purpose, business,
    } = company;

    const {
      opcoRegisterCPF, roles, sectors, business: selecBusiness, titanEnvironment, segmentosCnae,
    } = this.props;

    const isCpfFilled = opcoRegisterCPF && cnpj.length <= 11;

    const purposes = [
      {
        id: 'consumption',
        name: `${I18n.t('consumption')}`,
      }, {
        id: 'industrialization',
        name: `${I18n.t('industrialization')}`,
      }, {
        id: 'resale',
        name: `${I18n.t('resale')}`,
      },
    ];

    if (finalize) {
      return (
        <main>
          <div className="section section-panel">
            <div className="container">
              <div className="box-content">
                <div className="basket cart-status">
                  <span className="cart-status-image" style={{ backgroundImage: 'url(/images/check.svg)' }} />
                  <p style={{ fontSize: 'x-large' }}>{I18n.t('successNewRegister')}</p>
                  <br />
                  <p style={{ fontSize: 'large' }}>{I18n.t('successNewRegisterTextTwo')}</p>
                  <br />
                  <a role="presentation" onClick={this.onClickGoToLogin} className="btn cursorPointer">
                    {I18n.t('login')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      );
    }

    if (finalizeError) {
      return (
        <main>
          <div className="section section-panel">
            <div className="container">
              <div className="box-content">
                <div className="basket cart-status">
                  <span className="cart-status-image" style={{ backgroundImage: 'url(/images/check.svg)' }} />
                  <p style={{ fontSize: 'x-large' }}>{I18n.t('errorNewRegister')}</p>
                  <br />
                  <p style={{ fontSize: 'large' }}>{I18n.t('errorNewRegisterText')}</p>
                </div>
              </div>
            </div>
          </div>
        </main>
      );
    }

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('loginNewRegister')}</h1>

            <div className="panel-content">
              <form onSubmit={this.handleFinalize}>
                <div className="register">

                  <div className="register-coll">
                    <span className="register-title">{I18n.t('loginNewRegisterData')}</span>

                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('email')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('insertEmail')}
                          value={email}
                          maxLength={inputSize.max}
                          onChange={e => this.setValue('basic', 'email', e.target.value.trim())}
                          onBlur={() => this.onBlurBasic('email', email)}
                          required
                        />
                      </label>
                      {emailError ? <p className="error-msg">{emailError}</p> : ''}
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {opcoRegisterCPF ? I18n.t('loginNewRegisterCnpjCpf') : I18n.t('cnpj')}
                        <input
                          className="fld"
                          type="text"
                          value={this.formatCpnjCpf(cnpj, opcoRegisterCPF)}
                          placeholder={opcoRegisterCPF ? I18n.t('loginNewRegisterPlaceCnpjCpf') : I18n.t('loginNewRegisterPlaceCnpj')}
                          onChange={e => this.setValue('basic', 'cnpj', this.removeMarkCnpjCpf(e.target.value.trim()))}
                          onBlur={() => this.onBlurBasic(isCpfFilled ? 'cpf' : 'cnpj', cnpj)}
                          required
                        />
                      </label>
                      {cnpjError ? <p className="error-msg">{cnpjError}</p> : ''}
                    </div>

                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('firstName')}
                        <input
                          className="fld"
                          type="text"
                          maxLength={inputSize.maxDefault}
                          value={firstName}
                          placeholder={I18n.t('loginNewRegisterPlaceFirstName')}
                          onChange={e => this.setValue('user', 'firstName', e.target.value.replace(/[0-9]/g, ''))}
                          required
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('lastName')}
                        <input
                          className="fld"
                          type="text"
                          maxLength={inputSize.maxDefault}
                          value={lastName}
                          placeholder={I18n.t('loginNewRegisterPlaceLastName')}
                          onChange={e => this.setValue('user', 'lastName', e.target.value.replace(/[0-9]/g, ''))}
                          required
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('birthDate')}
                        <input
                          className="fld"
                          type="date"
                          maxLength={inputSize.maxDefault}
                          value={birthDate}
                          onChange={e => this.setValue('user', 'birthDate', e.target.value)}
                        />
                      </label>
                    </div>
                    {(type === 'cnpj' || !opcoRegisterCPF) && (
                      <React.Fragment>
                        <div className="register__group">
                          <label className="lbl">
                            {I18n.t('job')}
                            <div className="select select--white">
                              <select defaultValue={role} onChange={e => this.setValue('user', 'role', e.target.value)} required>
                                <option value="">{I18n.t('loginNewRegisterPlaceSelectRole')}</option>
                                {roles.map(item => (
                                  <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                              </select>
                            </div>
                          </label>
                        </div>
                        <div className="register__group">
                          <label className="lbl">
                            {I18n.t('sector')}
                            <div className="select select--white">
                              <select defaultValue={sector} onChange={e => this.setValue('user', 'sector', e.target.value)} required>
                                <option value="">{I18n.t('loginNewRegisterPlaceSelectSector')}</option>
                                {sectors.map(item => (
                                  <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                              </select>
                            </div>
                          </label>
                        </div>
                      </React.Fragment>
                    )}
                    <div className="register__group">
                      <InputMask
                        mask="(99) 99999-9999"
                        value={phone}
                        onChange={e => this.setValue('user', 'phone', e.target.value)}
                      >
                        {inputProps => (
                          <label className="lbl">
                            {I18n.t('phone2')}
                            <input
                              {...inputProps}
                              className="fld"
                              type="text"
                              placeholder={I18n.t('loginNewRegisterPlaceSelectPhone')}
                              required
                            />
                          </label>
                        )}
                      </InputMask>
                    </div>
                  </div>
                  <div className="register-coll">
                    <span className="register-title">{I18n.t('address')}</span>

                    <div className="register__group">
                      <InputMask
                        mask="99.999-999"
                        value={cep}
                        onChange={e => this.setValue('address', 'cep', e.target.value)}
                        onBlur={() => this.onBlurAddress('cep', cep)}
                      >
                        {inputProps => (
                          <label className="lbl">
                            {I18n.t('cep')}
                            <input
                              {...inputProps}
                              type="text"
                              className="fld"
                              placeholder={I18n.t('cep')}
                              required
                            />
                          </label>
                        )}
                      </InputMask>
                      {cepError ? <p className="error-msg">{cepError}</p> : ''}
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('street')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('loginNewRegisterPlaceStreet')}
                          maxLength={inputSize.maxDefault}
                          value={street}
                          onChange={e => this.setValue('address', 'street', e.target.value)}
                          required
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('number')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('loginNewRegisterPlaceNumber')}
                          maxLength={inputSize.maxDefault}
                          value={number}
                          onChange={e => this.setValue('address', 'number', e.target.value.replace(/[^0-9]/g, ''))}
                          required
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('complement')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('loginNewRegisterPlaceComplement')}
                          maxLength={inputSize.maxDefault}
                          value={complement}
                          onChange={e => this.setValue('address', 'complement', e.target.value)}
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('district')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('loginNewRegisterPlaceDistrict')}
                          maxLength={inputSize.maxDefault}
                          value={district}
                          onChange={e => this.setValue('address', 'district', e.target.value)}
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('city')}
                        <input
                          className="fld fld--grey"
                          type="text"
                          maxLength={inputSize.maxDefault}
                          value={city}
                          onChange={e => this.setValue('address', 'city', e.target.value)}
                          disabled
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('state')}
                        <input
                          className="fld fld--grey"
                          type="text"
                          maxLength={inputSize.maxDefault}
                          value={state}
                          onChange={e => this.setValue('address', 'state', e.target.value)}
                          disabled
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('country')}
                        <input
                          className="fld fld--grey"
                          type="text"
                          maxLength={inputSize.maxDefault}
                          value={country}
                          onChange={e => this.setValue('address', 'country', e.target.value)}
                          disabled
                        />
                      </label>
                    </div>
                  </div>
                  <div className="register-coll">
                    <span className="register-title">{I18n.t('loginNewRegisterDataBusiness')}</span>

                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('companyName')}
                        <input
                          className="fld"
                          type="text"
                          placeholder={I18n.t('loginNewRegisterPlaceCompanyName')}
                          minLength={2}
                          maxLength={inputSize.maxDefault}
                          value={name}
                          onChange={e => this.setValue('company', 'name', e.target.value)}
                          required={!isCpfFilled}
                          disabled={isCpfFilled}
                        />
                      </label>
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        <input
                          type="checkbox"
                          checked={!!hasIe}
                          onChange={e => this.setValue('company', 'hasIe', e.target.checked)}
                          disabled={isCpfFilled}
                        />
                        {` ${I18n.t('loginNewRegisterCheckInsSta')}`}
                      </label>
                      <input
                        className="fld"
                        type="text"
                        placeholder={I18n.t('stateRegistration')}
                        maxLength={19}
                        value={ie}
                        onChange={e => this.setValue('company', 'ie', e.target.value.replace(/[^0-9]+/g, ''))}
                        disabled={isCpfFilled || !hasIe}
                        required={hasIe}
                      />
                      {hasIe && !isCpfFilled && (
                        <div style={{ padding: '12px 2px', color: 'red' }}>
                          <p>{I18n.t('stateRegistrationNotice')}</p>
                        </div>
                      )}
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('purpose')}
                        <div className="select select--white">
                          <select
                            defaultValue={purpose}
                            onChange={e => this.setValue('company', 'purpose', e.target.value)}
                            required={!isCpfFilled}
                            disabled={isCpfFilled}
                          >
                            <option value="">{I18n.t('loginNewRegisterPlaceSelectPurpose')}</option>
                            {purposes.map(item => (
                              <option key={item.id} value={item.id}>{item.name}</option>
                            ))}
                          </select>
                        </div>
                      </label>
                      {company.purpose === 'resale' && company.ie === '' && (
                      <div style={{ padding: '12px 2px', color: 'red' }}>
                        <p>{I18n.t('noticeResaleOption')}</p>
                      </div>
                      )}
                    </div>
                    <div className="register__group">
                      <label className="lbl">
                        {I18n.t('business')}
                        <div className="select select--white">
                          {
                            titanEnvironment ? (
                              <select
                                defaultValue={business}
                                onChange={e => this.setValue('company', 'business', e.target.value)}
                                required={!isCpfFilled}
                                disabled={isCpfFilled}
                              >
                                <option value="">{I18n.t('loginNewRegisterPlaceSelectBusiness')}</option>
                                {segmentosCnae.map(item => (
                                  <option key={item.id} value={item.segmentId}>{item.cnae}</option>
                                ))}
                              </select>
                            ) : (
                              <select
                                defaultValue={business}
                                onChange={e => this.setValue('company', 'business', e.target.value)}
                                required={!isCpfFilled}
                                disabled={isCpfFilled}
                              >
                                <option value="">{I18n.t('loginNewRegisterPlaceSelectBusiness')}</option>
                                {selecBusiness.map(item => (
                                  <option key={item.id} value={item.id}>{`${item.id}${'  '}-${'  '}${item.name}`}</option>
                                ))}
                              </select>
                            )
                          }
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="register-row">
                    <button type="submit" disabled={emailError || cnpjError} style={{ cursor: (emailError || cnpjError) && 'not-allowed' }} className="btn btn-register">{I18n.t('loginNewRegisterFinalize')}</button>
                    {error ? <p className="error-msg">{error}</p> : ''}
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>

      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  newRegister: data => dispatch(newRegister(data)),
  check: (email, cnpj, type) => dispatch(checkRegister(email, StringHelper.keepOnlyNumber(cnpj), type)),
  buscaCep: cep => dispatch(buscaCep(cep)),
  recoverPassword: email => dispatch(recoverPassword(email)),
});

const mapStateToProps = state => ({
  roles: state.settings.contact && state.settings.contact.roles,
  sectors: state.settings.contact && state.settings.contact.sectors,
  business: state.settings.contact && state.settings.contact.business,
  segmentosCnae: state.settings.contact && state.settings.contact.segmentosCnae,
  titanEnvironment: state.settings.titanEnvironment,
  documentType: state.settings.documentType,
  opcoRegisterCPF: (state.settings.opcoRegisterCPF && state.settings.opcoRegisterCPF === 'true') ? true : false,
  rdStationApiKey: state.settings.rdStationApiKey,
});

export default connect(mapStateToProps, mapDispatchToProps)(NewRegisterPage);
